import { OauthCallback } from '@/packages/auth/pages/oauth';
import { AuthRoutes } from '@/packages/auth/routes';
import { VerificationPage } from '@/packages/certificates';
import type { AppRoute } from '@/routes/interfaces';
import { session_path } from '@/utils/routes';

export const publicRoutes: Record<string, AppRoute> = {
  login: {
    label: 'Login',
    element: AuthRoutes,
    path: session_path(),
  },
  oauthCallback: {
    label: 'Oauth Callback',
    path: '/auth_callback',
    element: OauthCallback,
  },
  certificates: {
    label: 'Certificado',
    path: '/certificados/:uuid',
    element: VerificationPage,
  },
};
